import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]

  // A Turbo stream can replace the modal while it's open, which skips close()
  // and would otherwise leave the page permanently unscrollable.
  disconnect() {
    document.body.classList.remove("overflow-hidden")
  }

  open(event) {
    event.preventDefault()
    const name = event.params?.name
    const modal = name ? this.modalTargets.find(m => m.dataset.modalName === name) : this.modalTarget
    modal.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  close(event) {
    if (this.modalTargets.includes(event.target) || event.target.closest("[data-close]")) {
      this.closeAll()
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") this.closeAll()
  }

  closeAll() {
    this.modalTargets.forEach(m => m.classList.add("hidden"))
    document.body.classList.remove("overflow-hidden")
  }
}
